import { projectsApiClient } from "../common/axiosInstanceProjects";
import { handleAxiosError } from "../common/handleAxiosError";

export const getAllSections = async () => {
  try {
    const response = await projectsApiClient.get("/sections");
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener los proyectos");
  }
};